import { ReactNode } from 'react';

import { Link } from 'react-router-dom';

import signUpLeft from '@/assets/signup/signup-left.svg';
import signUpRight from '@/assets/signup/signup-right.svg';
import { SignUpSteps, useSignUpStore } from '@/stores/signup.store';

interface SignUpConstructionBackgroundProps {
  children: ReactNode;
}

export const SignUpConstructionBackground = ({ children }: SignUpConstructionBackgroundProps) => {
  const { signUpStep } = useSignUpStore();
  return (
    <div className="bg-grey-1 flex h-screen flex-col items-center">
      <div className="animate-in fade-in z-50 m-auto flex content-center items-center justify-center gap-25 duration-700">
        <img src={signUpLeft} alt="man pointing out at the form" className="hidden md:block md:h-[280px] lg:block lg:h-[420px]" />
        <div className="flex flex-col items-center gap-4">
          <div className="m-auto flex h-fit w-[400px] flex-col gap-4 rounded bg-white p-8 shadow">{children}</div>
          {[SignUpSteps.Email, SignUpSteps.UserInfo].includes(signUpStep) && (
            <div className="text-sm">
              Already have a Gearbelt account?
              <Link to="/login" className="pl-1 font-bold hover:underline">
                Login
              </Link>
            </div>
          )}
        </div>
        <img src={signUpRight} alt="woman pointing out at the form" className="hidden md:block md:h-[280px] lg:block lg:h-[420px]" />
      </div>
    </div>
  );
};
